import { render, staticRenderFns } from "./LayersDelete.vue?vue&type=template&id=9ccd0240&scoped=true&"
import script from "./LayersDelete.vue?vue&type=script&lang=js&"
export * from "./LayersDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccd0240",
  null
  
)

export default component.exports